module.exports = __webpack_public_path__ + "media/images/ir/profile/photo_kashiwagi-8bcb5ad103efd4b8b31352800ff42c6c.jpg";